
import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchDataFromApi } from '../../helpers/api';
import { getCurrentToken } from '../../utility/getCurrentToken';
import { logout } from '../slices/authSlice';
import { resetInstances } from './instancesSlice';
import { resetImages } from './imagesSlice';
import { resetFlavors } from './flavorsSlice';
import axiosInstance from '../../utility/axiosInstance';
import {handleAxiosError} from "../../helpers/handleAxiosError";
interface OverviewData {
    totalInstances: number;
    totalVCPUs: number;
    totalRAM: number;
    totalStorage: number;
    totalVolumes: number;
    totalVolumesCount: number;
    totalSnapshots: number;
    [key: string]: any;
}

interface OverviewState {
    data: OverviewData | null;
    status: 'idle' | 'loading' | 'succeeded' | 'failed';
    error: string | null;
}

const initialState: OverviewState = {
    data: null,
    status: 'idle',
    error: null,
};

export const fetchOverviewData = createAsyncThunk(
    'overview/fetchOverviewData',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get('/v1/overview');
            return response.data;
        } catch (error) {
            console.error("Failed to fetch DNS:", error);
            return rejectWithValue(handleAxiosError(error));
        }
    }
);

const overviewSlice = createSlice({
    name: 'overview',
    initialState,
    reducers: {
        setOverviewData: (state, action: PayloadAction<OverviewData>) => {
            state.data = action.payload;
        },
        resetOverview: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchOverviewData.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchOverviewData.fulfilled, (state, action: PayloadAction<OverviewData>) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchOverviewData.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            });
    },
});

export const { setOverviewData, resetOverview } = overviewSlice.actions;
export default overviewSlice.reducer;